import {
  getMemberCardInfo, getMemberShoppingRecord
} from '../../../services/crmService/cardService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {};

// getters
const getters = {};

// actions
const actions = {
  // 會員卡
  async getInfoHandler() {
    const data = await getMemberCardInfo();
    return data;
  },
  // 消費紀錄
  async getShoppingRecordHandler() {
    const data = await getMemberShoppingRecord();
    return data;
  },
};

// mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
